module.exports = __webpack_public_path__ + "static/media/poster.3e754350.jpeg";